import { Field, FormTheme } from '@kanda-libs/ks-component-ts';

import DepositSelectButton from './DepositSelectButton';
import { CUSTOM_FIELD_PROPS } from './constants';
import useDepositSelect from './useDepositSelect';

const DepositSelect: React.FunctionComponent = function () {
  const {
    gridClassName,
    buttons,
    showCustomField,
    customValidation,
    customDepositTtitle,
    onBlur,
  } = useDepositSelect();
  return (
    <>
      <h3 className="text-14-22-b md:text-16-20-b mb-3">
        Select a deposit amount to pay
      </h3>
      <div className={gridClassName}>
        {buttons.map(({ value, percentage, key, id, onClick }) => (
          <DepositSelectButton
            value={value}
            percentage={percentage}
            id={id}
            key={key}
            onClick={onClick}
          />
        ))}
      </div>
      {showCustomField && (
        <>
          <p className="text-14-22-b md:text-16-20-b mb-3 mt-4">
            {customDepositTtitle}
          </p>
          <FormTheme variant="checkout">
            <Field.Validator validation={customValidation}>
              <Field.NumberInput
                {...CUSTOM_FIELD_PROPS}
                name="deposit"
                onBlur={onBlur}
                className="!-mb-0"
              />
            </Field.Validator>
          </FormTheme>
        </>
      )}
    </>
  );
};

export default DepositSelect;
